"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnisLogoColor = exports.LogoPositions = exports.DataSources = exports.WebAppMetrics = void 0;
var WebAppMetrics;
(function (WebAppMetrics) {
    WebAppMetrics["OCCUPANCY_RATE"] = "OCCUPANCY_RATE";
    WebAppMetrics["AFFLUENCE_IN"] = "AFFLUENCE_IN";
    WebAppMetrics["INSIDE"] = "INSIDE";
    WebAppMetrics["WAITING_TIME"] = "WAITING_TIME";
    WebAppMetrics["DWELL_TIME"] = "DWELL_TIME";
    WebAppMetrics["LIMIT"] = "LIMIT";
})(WebAppMetrics = exports.WebAppMetrics || (exports.WebAppMetrics = {}));
var DataSources;
(function (DataSources) {
    DataSources["API"] = "API";
    DataSources["FIREBASE_LEGACY"] = "FIREBASE_LEGACY";
    DataSources["FIREBASE_RETAIL"] = "FIREBASE_RETAIL";
    DataSources["FIREBASE_VISION"] = "FIREBASE_VISION";
})(DataSources = exports.DataSources || (exports.DataSources = {}));
var LogoPositions;
(function (LogoPositions) {
    LogoPositions["BOTTOM"] = "BOTTOM";
    LogoPositions["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
    LogoPositions["TOP"] = "TOP";
})(LogoPositions = exports.LogoPositions || (exports.LogoPositions = {}));
var TechnisLogoColor;
(function (TechnisLogoColor) {
    TechnisLogoColor["LIGHT"] = "LIGHT";
    TechnisLogoColor["DARK"] = "DARK";
})(TechnisLogoColor = exports.TechnisLogoColor || (exports.TechnisLogoColor = {}));
